import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Dash = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 8C2 7.66406 2.27233 7.39172 2.60828 7.39172H13.3917C13.7277 7.39172 14 7.66406 14 8C14 8.33594 13.7277 8.60828 13.3917 8.60828H2.60828C2.27233 8.60828 2 8.33594 2 8Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Dash;
